/* istanbul ignore file */
export default {
  caretDown: 'Caret Down',
  caretRight: 'Caret Right',
  collapse: 'collapse',
  expand: 'expand',
  subRowControlTitle: 'Expand Row'
};
